/**
 * Translates various dynamic labels and statuses to the active UI language.
 */

export function translateCompetencyLabel(competency: string, t: any): string {
  if (!competency) return "";
  const c = competency.trim().toLowerCase();
  
  if (c === "reading" || c === "compreensão escrita" || c === "compreensão escrita (ce)" || c === "ce" || c === "lectures") {
    return t("history.readingTitle", "Compréhension écrite");
  }
  if (c === "listening" || c === "compreensão oral" || c === "compreensão oral (co)" || c === "co" || c === "écoutes" || c === "ecoutes") {
    return t("history.listeningTitle", "Compréhension orale");
  }
  if (c === "writing" || c === "expressão escrita" || c === "expressão escrita (ee)" || c === "ee" || c === "écritures" || c === "ecritures") {
    return t("history.writingTitle", "Expression écrite");
  }
  return competency;
}

export function translateStatusLabel(status: string, t: any): string {
  if (!status) return "";
  const s = status.trim().toLowerCase();
  
  if (s === "critical" || s === "crítico" || s === "critico") {
    return t("status.critical", "Critique");
  }
  if (s === "needs attention" || s === "precisa de atenção" || s === "precisa atencao") {
    return t("status.needsAttention", "À travailler");
  }
  if (s === "on track" || s === "no caminho" || s === "no rumo") {
    return t("status.onTrack", "En bonne voie");
  }
  if (s === "goal achieved" || s === "meta atingida" || s === "objetivo atingido") {
    return t("status.goalAchieved", "Objectif atteint");
  }
  if (s === "in progress" || s === "em progresso" || s === "em curso") {
    return t("status.inProgress", "En cours");
  }
  if (s === "stable" || s === "estável" || s === "estavel") {
    return t("status.stable", "Stable");
  }
  if (s === "improving" || s === "melhorando" || s === "em melhora" || s === "em evolução" || s === "strong") {
    return t("status.improving", "En progression");
  }
  if (s === "declining" || s === "piorando" || s === "em queda" || s === "em declínio") {
    return t("status.declining", "En baisse");
  }
  if (s === "medium" || s === "média" || s === "media" || s === "médio" || s === "medio") {
    return t("status.medium", "Moyen");
  }
  if (s === "hard" || s === "difícil" || s === "dificil") {
    return t("status.hard", "Difficile");
  }
  if (s === "easy" || s === "fácil" || s === "facil") {
    return t("status.easy", "Facile");
  }
  return status;
}

export function translateActionLabel(action: string, t: any): string {
  if (!action) return "";
  const a = action.trim().toLowerCase();
  
  if (a === "review" || a === "revisar") {
    return t("actions.review", "Réviser");
  }
  if (a === "practice" || a === "praticar") {
    return t("actions.practice", "Pratiquer");
  }
  if (a === "start now" || a === "começar agora" || a === "comecar agora" || a === "começar") {
    return t("actions.startNow", "Commencer");
  }
  if (a === "study now" || a === "estudar agora" || a === "estudar") {
    return t("actions.studyNow", "Étudier maintenant");
  }
  if (a === "next" || a === "próximo" || a === "proximo" || a === "próxima" || a === "proxima") {
    return t("actions.next", "Suivant");
  }
  if (a === "previous" || a === "anterior") {
    return t("actions.previous", "Précédent");
  }
  if (a === "back" || a === "voltar") {
    return t("actions.back", "Retour");
  }
  if (a === "save" || a === "salvar" || a === "gravar") {
    return t("actions.save", "Enregistrer");
  }
  if (a === "cancel" || a === "cancelar") {
    return t("actions.cancel", "Annuler");
  }
  if (a === "add word" || a === "adicionar palavra" || a === "adicionar termo") {
    return t("actions.addWord", "Ajouter un mot");
  }
  if (a === "register error" || a === "registrar erro" || a === "adicionar registro") {
    return t("actions.registerError", "Enregistrer une erreur");
  }
  return action;
}

import { translateErrorCategory as baseTranslateErrorCategory } from "./errorTranslation";
export function translateErrorCategory(category: string, t: any): string {
  return baseTranslateErrorCategory(category, t);
}
